export default __webpack_public_path__ + "static/media/vid.33cf81b5.webm";